import noop from 'lodash/noop';
import 'rxjs/add/operator/combineLatest';
import {buildInjector} from '../../../_libs/angular-utils';
import fuse from '../../../_libs/redux-fusion';
import {getItemFromState} from '../../../_libs/redux-observable-list';
import {stateGoForward} from '../../../app/actions';
import {getProjectReduxItem} from '../../../app/model/reducers/state';
import {buildBreadcrumbPath$, getProjectIdFromPath} from '../../../app/navigation/utils';
import {
  ReduxListFilterStreamedContainer,
  ReduxListStreamedContainer,
} from '../../../core-utilities/redux/ReduxListContainer';
import {TaskType} from '../../../tasks/enums/TaskType';
import {componentOptions, reduxList} from '../../redux/assetProjectList';
import {projectStates} from '../../router-config';
import {ProjectViewAssetsView} from './ProjectViewAssetsView';


// Use legacy service to locally handle per-item requests, since they are allowed to occur in parallel
const dependencies = {};
export const injector = buildInjector(dependencies, [
  'rxPermissionsService',
]);

export const StreamedComponent = (state$, dispatch) => (props$) => {
  const onNavToManageAssets = () => dispatch(stateGoForward({state: projectStates.projectsManageAssets}));

  const breadcrumbPath$ = buildBreadcrumbPath$({state$, taskType: TaskType.PROJECT});

  const projectItem$ = state$
    .map(getProjectReduxItem)
    .distinctUntilChanged();

  const permissions$ = observePermissions();

  return props$
    .combineLatest(
      breadcrumbPath$,
      projectItem$,
      permissions$,
      (props, breadcrumbPath, projectItem, permissions) => ({
        ...props,
        breadcrumbPath,
        project: getItemFromState(projectItem),
        parentId: getProjectIdFromPath(breadcrumbPath, TaskType.PROJECT),
        // init: !!getProjectIdFromPath(breadcrumbPath, TaskType.PROJECT),
        canManageAssets: permissions.canManageAssets,
        onNavToManageAssets,
      }));
};

const ListComponent = ReduxListStreamedContainer(ProjectViewAssetsView, reduxList, componentOptions);
const FilteredListComponent = ReduxListFilterStreamedContainer(ListComponent, reduxList, componentOptions);
export const ProjectViewAssetsContainer = fuse(StreamedComponent)(FilteredListComponent);

function observePermissions() {
  const rxPermissionsService = dependencies.rxPermissionsService;
  return rxPermissionsService.userProjectRoleData$
    .map(rxPermissionsService.projectStateFn(getVIEW_ACTIONS))
    .startWith({permissions: {}, hasPermission: noop});
}

function getVIEW_ACTIONS(roleData) {
  const isLocked = roleData.projectIsLocked;
  return {
    canManageAssets: isLocked ? 'project_assets_create_locked' : 'project_assets_create',
    canDownloadFiles: 'task_fulfillments_view',
    canEdit: 'project_data_edit',
  };
}



// WEBPACK FOOTER //
// ./src/js/projects/components/ProjectViewAssets/ProjectViewAssetsContainer.js